module.exports = __webpack_public_path__ + "static/media/speaker_Annex 81_Stephen.03cc73e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_Annex 81_Stephen.jpg
// module id = 248
// module chunks = 0